@if (temperatureValue()!=null && temperatureValue()!=undefined || windForce()) {
<div class="ev-card" id="wind-panel" data-testid="wind-panel">
  @if (temperatureValue()!=null && temperatureValue()!=undefined) {
    <div class="wind-el">
      @if (temperatureImg()) {
        <span class="weather-icon" [appSvgRecolor]="'assets/icons/default/weather/' + temperatureImg()"></span>
      }
      <div class="temperature-value wind-text" data-testid="wind-panel-temperature-text">
        <h6>{{ temperatureValueText() }} </h6>
        <h6 class="unit-text">{{ temperatureUnit() }}</h6>
      </div>
    </div>
  }
  @if (windForce()) {
    <div class="wind-el">
      <!-- rotation lives on the wrapper: appSvgRecolor swaps its host for the <svg>, so ngStyle must not sit on that element -->
      <span class="wind-arrow" data-testid="wind-panel-arrow-icon" [ngStyle]="{'transform': 'rotate(' + windDeg() + 'deg)' }">
        <span [appSvgRecolor]="'assets/icons/default/ui/wind_icon.svg'"></span>
      </span>
        <div class="wind-text" data-testid="wind-panel-wind-text">
          <h6>{{ windForceText() }} </h6>
          <h6 class="unit-text"> {{ windUnit() }}</h6>
        </div>
      </div>
    }
</div>
}